// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__PRqhr","banner_title":"banner_banner_title__37YrF","container":"banner_container__NUiEs","cover":"banner_cover__tMtT0"};